import { Box, Typography } from "@mui/material";
import BinIcon from "assets/icons/bin.svg";
import { Business } from "lib/features/business/types";
import { businessActionStyles } from "styles/BusinessListDirectory/businessAction.styles";
import { getBusinessImageSource } from "util/getImageSource";

interface BusinessActionCardProps {
  business: Business;
  handleBusinessRecords?: (business: Business, action: boolean) => void;
  isDeletable?: boolean;
}
const BusinessActionCard = ({
  business,
  handleBusinessRecords,
  isDeletable = true,
}: BusinessActionCardProps) => {
  return (
    <Box sx={businessActionStyles.selectedBusinessCard}>
      <img
        src={getBusinessImageSource(business)}
        style={businessActionStyles.selectedBusinessImage}
      />
      <Box sx={{ flex: 1 }}>
        <Typography sx={businessActionStyles.businessName}>
          {business.business}
        </Typography>
        <Typography sx={businessActionStyles.businessAddress}>
          {business.address1}
        </Typography>
        {isDeletable && handleBusinessRecords && (
          <Box
            sx={businessActionStyles.binButton}
            onClick={() => handleBusinessRecords(business, false)}
          >
            <img src={BinIcon} alt="bin-icon" />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default BusinessActionCard;
